import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { SnowplowTitleContextGraphql, SnowplowOldModuleContext } from '@/helpers/tracking/providers/snowplow-contexts';

import { ObjectType } from '@/@types/graphql-types';
import type { TitleType, GlobalModuleName } from '@/helpers/composables/useGlobalTitles';

import HiddenHorizontalScrollbar from '@/components/HiddenHorizontalScrollbar.vue';
import PosterGraphql from '@/components/poster/PosterGraphql.vue';
import TitleDetailLink from '@/components/nav/links/TitleDetailLink.vue';
import Top10TitleSwiper from '@/components/popular/provider-module/Top10TitleSwiper.vue';
import UKHomeTop10SwiperSlide from '@/components/experiments/UKHomeExp2/UKHomeTop10SwiperSlide.vue';
import WatchNowButtonNew from '@/components/buttons/WatchNowButtonNew.vue';

import { useGlobalTitles } from '@/helpers/composables/useGlobalTitles';
import { useI18n } from '@/helpers/composables/useI18n';

import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { getSelectedTab } from '@/components/popular/provider-module/helper';
import { useRoutingStore } from '@/stores/pinia/useRoutingStore';
import { storeToRefs } from 'pinia';


export default /*#__PURE__*/_defineComponent({
  __name: 'UKHomeTop10Titles',
  props: {
    country: null,
    language: null,
    objectType: null,
    type: null,
    moduleName: null,
    variant: null
  },
  setup(__props: any) {

const props = __props as {
	country: string;
	language: string;
	objectType?: ObjectType.Movie | ObjectType.Show;
	type: TitleType;
	moduleName: GlobalModuleName;
	variant?: 'variant_1' | 'variant_2';
};



const { tc } = useI18n();

const { activeRoute } = storeToRefs(useRoutingStore());

const { titles } = useGlobalTitles(props);

const moduleContext = computed(() => new SnowplowOldModuleContext('', -1, props.moduleName, ''));

const title = computed(() => {
	if (props.objectType === ObjectType.Movie) {
		return tc('WEBAPP_GLOBAL_TOP_10_MOVIE');
	} else if (props.objectType === ObjectType.Show) {
		return tc('WEBAPP_GLOBAL_TOP_10_SHOW');
	}

	if (props.moduleName === 'MAIN_JWTV_TVOD') {
		return tc('WEBAPP_GLOBAL_JWTV_TVOD');
	}

	return tc('WEBAPP_GLOBAL_TOP_10');
});

const text = computed(() => {
	if (props.objectType === ObjectType.Movie) {
		return tc('WEBAPP_GLOBAL_TOP_10_MOVIE_TEXT');
	} else if (props.objectType === ObjectType.Show) {
		return tc('WEBAPP_GLOBAL_TOP_10_SHOW_TEXT');
	}

	if (props.moduleName === 'MAIN_JWTV_TVOD') {
		return tc('WEBAPP_GLOBAL_JWTV_TVOD_TEXT');
	}

	return '';
});

function getTitleContext(title: any) {
	return new SnowplowTitleContextGraphql(title.objectId, title.objectType);
}

function preventNavigation($event: Event) {
	$event.preventDefault();
	$event.stopPropagation();
	$event.stopImmediatePropagation();
}

function handlePosterClick(title: any, index: number) {
	const selectedTab = getSelectedTab(activeRoute.value?.name);

	TrackingHelper.trackEvent(
		'userinteraction',
		{
			action: 'title_clicked',
			label: 'uk-home-top-10-titles',
			property: selectedTab,
			value: index,
		},
		[getTitleContext(title), moduleContext.value]
	);
}

function handleMobileSlideChange(payload: { direction: string; position: number }) {
	TrackingHelper.trackEvent(
		'userinteraction',
		{
			action: 'swipe_clicked',
			label: payload.direction,
			value: payload.position,
			property: 'global_home_swiper',
		},
		[moduleContext.value]
	);
}

return { __sfc: true,props, tc, activeRoute, titles, moduleContext, title, text, getTitleContext, preventNavigation, handlePosterClick, handleMobileSlideChange, HiddenHorizontalScrollbar, PosterGraphql, TitleDetailLink, Top10TitleSwiper, UKHomeTop10SwiperSlide, WatchNowButtonNew }
}

})